import { Directive, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appFormInput]',
})
export class FormInputDirective {
  constructor(@Optional() @Self() public ngControl: NgControl) {}
}
